export default {
   gGet: (state, getters, rootState) => (id) => {
     return state.projects.find(project => project.id === id);
   }
}
